import React, { useState } from "react";
import "../../styles/UserForm.css";
import { rm_create } from "../../services/roleMasterService";

export default function AddRole({ onClose, onSuccess }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    name: "",
    code: "",
    description: "",
  });

  const update = (k, v) =>
    setForm((prev) => ({ ...prev, [k]: v }));

  const validate = () => {
    if (!form.name.trim() || !form.code.trim()) {
      setError("Name and Code are required");
      return false;
    }
    return true;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      setSaving(true);
      const res = await rm_create({
        ...form,
        code: form.code.toUpperCase().trim(),
      });
      if (res?.data?.success) {
        onSuccess();
        onClose();
      } else {
        setError(res?.data?.message || "Failed to create");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="uf-modal" onClick={onClose}>
      <div
        className="uf-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="uf-header">
          <h5 className="text-white">Add Role</h5>
          <button onClick={onClose}>✕</button>
        </div>

        <form onSubmit={submit}>
          <div className="uf-body">
            {error && (
              <div className="alert alert-danger py-2">
                {error}
              </div>
            )}
            <div className="uf-grid">
              <div>
                <label className="form-label">Name *</label>
                <input
                  className="form-control"
                  value={form.name}
                  onChange={(e) => update("name", e.target.value)}
                />
              </div>
              <div>
                <label className="form-label">Code *</label>
                <input
                  className="form-control"
                  value={form.code}
                  onChange={(e) => update("code", e.target.value)}
                  placeholder="E.g. TENANT_ADMIN"
                />
              </div>
              <div>
                <label className="form-label">Description</label>
                <input
                  className="form-control"
                  value={form.description}
                  onChange={(e) => update("description", e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="uf-actions">
            <button
              type="button"
              className="btn btn-cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={saving}
            >
              {saving ? "Saving…" : "Save Role"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
